import React from 'react';
import { Link } from 'react-router-dom';
import { createPageUrl } from 'utils';
import { Phone, Mail, MapPin } from 'lucide-react';

export default function Footer() {
    return (
        <footer className="bg-gray-950 text-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
                    {/* Brand */}
                    <div className="space-y-6">
                        <div className="flex items-center gap-3">
                            <img
                                src="/images/tecnosys-logo-footer-new.jpg"
                                alt="Tecnosys Logo"
                                className="h-12 w-auto object-contain bg-white rounded-lg p-1"
                            />
                        </div>
                        <p className="text-gray-400 text-sm leading-relaxed">
                            Da oltre 20 anni garantiamo continuità energetica in Sicilia.
                            Specializzati in UPS professionali per infrastrutture critiche.
                        </p>
                        <div className="flex gap-4">
                            <a
                                href="https://wa.me/393296139684"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-green-600 transition-colors"
                            >
                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                                </svg>
                            </a>
                            <a
                                href="mailto:info@tecnosys-ups.com"
                                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-blue-600 transition-colors"
                            >
                                <Mail className="w-5 h-5" />
                            </a>
                        </div>
                    </div>

                    {/* Pagine */}
                    <div>
                        <h4 className="text-sm font-semibold uppercase tracking-wider text-gray-400 mb-6">Pagine</h4>
                        <ul className="space-y-3">
                            {[
                                { label: 'Riparazioni', href: 'Riparazioni' },
                                { label: 'Manutenzione', href: 'Manutenzione' },
                                { label: 'Chi Siamo', href: 'ChiSiamo' },
                                { label: 'FAQ', href: 'FAQ' },
                                { label: 'Contatti', href: 'Contatti' },
                                { label: 'Privacy Policy', path: '/privacy' },
                                { label: 'Cookie Policy', path: '/cookie-policy' },
                            ].map((item) => (
                                <li key={item.label}>
                                    <Link
                                        to={item.path || createPageUrl(item.href)}
                                        className="text-gray-400 hover:text-white transition-colors"
                                    >
                                        {item.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Contatti */}
                    <div>
                        <h4 className="text-sm font-semibold uppercase tracking-wider text-gray-400 mb-6">Contatti</h4>
                        <ul className="space-y-4">
                            <li className="flex items-start gap-3">
                                <MapPin className="w-5 h-5 text-blue-500 shrink-0 mt-0.5" />
                                <span className="text-gray-400">Palermo, Sicilia<br />Operativi in tutta la Sicilia</span>
                            </li>
                            <li className="flex items-center gap-3">
                                <Phone className="w-5 h-5 text-blue-500 shrink-0" />
                                <a href="tel:+393296139684" className="text-gray-400 hover:text-white transition-colors">
                                    329 6139684
                                </a>
                            </li>
                            <li className="flex items-center gap-3">
                                <Mail className="w-5 h-5 text-blue-500 shrink-0" />
                                <a href="mailto:info@tecnosys-ups.com" className="text-gray-400 hover:text-white transition-colors">
                                    info@tecnosys-ups.com
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Bottom */}
                <div className="mt-16 pt-8 border-t border-white/10 text-center">
                    <div className="flex flex-col md:flex-row justify-center items-center gap-4">
                        <p className="text-gray-500 text-sm">
                            © {new Date().getFullYear()} Tecnosys di Lo Verso Salvatore. Tutti i diritti riservati.
                        </p>
                        <p className="text-gray-500 text-sm">
                            P.IVA IT 05918540823
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
}